// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"ContractSavingsProfilingPoliticallyExposedPerson_modal-content_7vLRA"};